import React, {useEffect, useState} from 'react';
import {DictItemDto} from "../../../../../../modules/dict/dto/DictItemDto";
import {RequestVisitorDto} from "../../../../../../modules/vms/dto/RequestVisitorDto";
import {useIntl} from "react-intl";
import {DictClassCode} from "../../../../../../modules/vms/constants/DictClassCode";
import {DictClassApi} from "../../../../../../modules/dict/api/DictClassApi";
import {HttpStatus} from "../../../../../../modules/common/enums/HttpStatus";
import {ValidateUtils} from "../../../../../../utils/ValidateUtils";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl, FormHelperText,
    Grid,
    IconButton,
    List, ListItem, ListItemText,
    Stack
} from "@mui/material";
import CancelButton from "../../../../../../components/buttons/CancelButton";
import SaveButton from "../../../../../../components/buttons/SaveButton";
import FormFieldText from "../../../../../../components/FormFieldText";
import PlateNumberDialog from "../../../../../../components/PlateNumberDialog";
import KeyboardIcon from "@mui/icons-material/Keyboard";
import FormFieldSelect from "../../../../../../components/FormFieldSelect";
import {VisitorDriveType} from "../../../../../../modules/vms/enums/VisitorDriveType";
import {PlateNumberColor} from "../../../../../../modules/vms/enums/PlateNumberColor";
import {VehicleType} from "../../../../../../modules/vms/enums/VehicleType";
import FormFieldDate from "../../../../../../components/FormFieldDate";
import dayjs from "dayjs";
import {Formats} from "../../../../../../constants/Formats";
import {VehicleFuelType} from "../../../../../../modules/vms/enums/VehicleFuelType";
import {VehicleEmissionStandard} from "../../../../../../modules/vms/enums/VehicleEmissionStandard";
import UploadFileButton from "../../../../../../components/buttons/UploadFileButton";
import DeleteIcon from "@mui/icons-material/Delete";
import {FileApi} from "../../../../../../modules/ftp/api/FileApi";
import {RequestVisitorAttachFile} from "../../../../../../modules/vms/dto/RequestVisitorAttachFile";
import {VisitorAttachFileClassify} from "../../../../../../modules/vms/enums/VisitorFileClassify";

export type VisitorDetailDialogProps = {
    onCancel: () => void;
    onOk: (requestVisitor: RequestVisitorDto) => void;
    open: boolean;
    requestVisitor: RequestVisitorDto;
    visitorIndex: number;
};

const VisitorDetailDialog: React.FC<VisitorDetailDialogProps> = (props) => {
    const intl = useIntl();

    const [messageMap, setMessageMap] = useState(new Map<string, string>());
    const [innerVisitor, setInnerVisitor] = useState<RequestVisitorDto>(props.requestVisitor);
    const [openPlateNumberDialog, setOpenPlateNumberDialog] = useState(false);
    // 访客类型
    const [visitorTypes, setVisitorTypes] = useState(new Array<DictItemDto>());

    useEffect(() => {
        // 查询证件类型字典项
        fetchDictClassList();
    }, []);

    useEffect(() => {
        setInnerVisitor(props.requestVisitor);
    }, [props.requestVisitor]);

    const fetchDictClassList = async () => {
        const codes = new Array<string>(DictClassCode.VMS_VISITOR_TYPE);
        const responseResult = await DictClassApi.getDictClassList(codes);
        if (responseResult.status === HttpStatus.SUCCESS) {
            for (let dictClass of responseResult.data) {
                switch (dictClass.code) {
                    case DictClassCode.VMS_VISITOR_TYPE:
                        setVisitorTypes(dictClass.dictItems);
                        break;
                }
            }
        }
    };

    const handleChange = (name: string, value: any) => {
        setInnerVisitor({...innerVisitor, [name]: value});
    };

    const handleOk = () => {
        if (!validate()) {
            return;
        }
        props.onOk(innerVisitor);
    };

    const handleClose = () => {
        props.onCancel();
    };

    const validate = () => {
        const newMessageMap = new Map<string, string>();
        if (innerVisitor.lastName === '') {
            newMessageMap.set('lastName', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_LAST_NAME_REQUIRED'}));
        }
        if (innerVisitor.firstName === '') {
            newMessageMap.set('firstName', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_FIRST_NAME_REQUIRED'}));
        }
        if (innerVisitor.mobile === '') {
            newMessageMap.set('mobile', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_MOBILE_REQUIRED'}));
        } else if (!ValidateUtils.isMobileNumber(innerVisitor.mobile)) {
            newMessageMap.set('mobile', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_MOBILE_FORMAT_ERROR'}));
        }
        if (innerVisitor.company === '') {
            newMessageMap.set('company', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_COMPANY_REQUIRED'}));
        }
        if (innerVisitor.plateNumber === '') {
            newMessageMap.set('plateNumber', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_PLATE_NUMBER_REQUIRED'}));
        }
        // if (innerVisitor.plateNumberColor === '') {
        //     newMessageMap.set('plateNumberColor', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_REQUIRED'}));
        // }
        // if (innerVisitor.vehicleType === '') {
        //     newMessageMap.set('vehicleType', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VEHICLE_TYPE_REQUIRED'}));
        // }
        // if (innerVisitor.vehicleRegistrationDate === '') {
        //     newMessageMap.set('vehicleRegistrationDate', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VEHICLE_REGISTRATION_DATE_REQUIRED'}));
        // }
        // if (innerVisitor.vehicleFuelType === '') {
        //     newMessageMap.set('vehicleFuelType', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_REQUIRED'}));
        // }
        // if (innerVisitor.vehicleEmissionStandard === '') {
        //     newMessageMap.set('vehicleEmissionStandard', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_REQUIRED'}));
        // }
        //
        // // 验证证件
        // if (!innerVisitor.attachFilesArray || innerVisitor.attachFilesArray.length <= 0) {
        //     newMessageMap.set('attachFileVehicleLicense', intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VEHICLE_LICENSE_UPLOAD_REQUIRED'}));
        // }

        setMessageMap(newMessageMap);
        return newMessageMap.size <= 0;
    };

    const handleUpload = async (file: File) => {
        let targetFolder = dayjs().format(Formats.DATE_SIMPLE);
        targetFolder = targetFolder.substr(0, 6) + "/" + targetFolder.substr(6, 7);
        const responseResult = await FileApi.uploadFile(targetFolder, "", file);
        if (responseResult.status === HttpStatus.SUCCESS) {
            // 更新访客对象的附件列表
            const newAttachFiles = [...innerVisitor.attachFilesArray];
            console.log(newAttachFiles);
            const newAttachFile = new RequestVisitorAttachFile();
            newAttachFile.fileId = responseResult.data;
            newAttachFile.classify = VisitorAttachFileClassify.Enum.VehicleLicense;
            newAttachFile.fileName = file.name;
            newAttachFiles.push(newAttachFile);
            console.log(newAttachFiles);
            handleChange("attachFilesArray", newAttachFiles);
        }
    }

    const handleRemoveAttachFile = (index: number) => {
        const newAttachFiles = [...innerVisitor.attachFilesArray];
        newAttachFiles.splice(index, 1);
        handleChange('attachFilesArray', newAttachFiles);
    }

    return (
        <Dialog open={props.open} onClose={handleClose} fullWidth={true}>
            <PlateNumberDialog open={openPlateNumberDialog} onOk={(value) => handleChange("plateNumber", value)}
                               onClose={() => setOpenPlateNumberDialog(false)}
                               value={innerVisitor.plateNumber}/>
            <DialogTitle>
                {props.visitorIndex >= 0 ? intl.formatMessage({id: 'VMS_REQUEST_VISITOR_MODIFY'}) : intl.formatMessage({id: 'VMS_REQUEST_VISITOR_CREATE'})}
            </DialogTitle>
            <DialogContent>
                <Grid container columnSpacing={2}>
                    <Grid item xs={6}>
                        <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_LAST_NAME"})}
                                       placeholder={intl.formatMessage({id: "VMS_REQUEST_VISITOR_LAST_NAME_REQUIRED"})}
                                       required={true} errorText={messageMap.get("lastName")}
                                       value={innerVisitor.lastName}
                                       onChange={(value) => {
                                           handleChange("lastName", value)
                                       }}/>
                    </Grid>
                    <Grid item xs={6}>
                        <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_FIRST_NAME"})}
                                       placeholder={intl.formatMessage({id: "VMS_REQUEST_VISITOR_FIRST_NAME_REQUIRED"})}
                                       required={true} errorText={messageMap.get("firstName")}
                                       value={innerVisitor.firstName}
                                       onChange={(value) => {
                                           handleChange("firstName", value)
                                       }}/>
                    </Grid>
                    <Grid item xs={6}>
                        <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_MOBILE"})}
                                       placeholder={intl.formatMessage({id: "VMS_REQUEST_VISITOR_MOBILE_REQUIRED"})}
                                       required={true} errorText={messageMap.get("mobile")}
                                       type={"number"}
                                       value={innerVisitor.mobile}
                                       onChange={(value) => {
                                           handleChange("mobile", value)
                                       }}/>
                    </Grid>
                    <Grid item xs={6}>
                        <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_COMPANY"})}
                                       placeholder={intl.formatMessage({id: "VMS_REQUEST_VISITOR_COMPANY_REQUIRED"})}
                                       required={true} errorText={messageMap.get("company")}
                                       value={innerVisitor.company}
                                       onChange={(value) => {
                                           handleChange("company", value)
                                       }}/>
                    </Grid>
                    <Grid item xs={6}>
                        <FormFieldSelect label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_DRIVE_TYPE"})}
                                         value={innerVisitor.driveType}
                                         onChange={(value) => {
                                             handleChange("driveType", value)
                                         }}
                                         items={VisitorDriveType.List.map((item) => {
                                             return {label: intl.formatMessage({id: item.label}), value: item.value}
                                         })}/>
                    </Grid>
                    <Grid item xs={6}>
                        <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_PLATE_NUMBER"})}
                                       placeholder={intl.formatMessage({id: "VMS_REQUEST_VISITOR_PLATE_NUMBER_REQUIRED"})}
                                       value={innerVisitor.plateNumber}
                                       required={true} errorText={messageMap.get("plateNumber")}
                                       endAdornment={
                                           <IconButton color="primary" onClick={() => setOpenPlateNumberDialog(true)}>
                                               <KeyboardIcon/>
                                           </IconButton>}/>
                    </Grid>
                    <Grid item xs={6}>
                        <FormFieldSelect label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR"})}
                                         value={innerVisitor.plateNumberColor}
                                         onChange={(value) => {
                                             handleChange("plateNumberColor", value)
                                         }}
                                         items={PlateNumberColor.List.map((item) => {
                                             return {label: intl.formatMessage({id: item.label}), value: item.value}
                                         })}/>
                    </Grid>
                    <Grid item xs={6}>
                        <FormFieldSelect label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_VEHICLE_TYPE"})}
                                         value={innerVisitor.vehicleType}
                                         onChange={(value) => {
                                             handleChange("vehicleType", value)
                                         }}
                                         items={VehicleType.List.map((item) => {
                                             return {label: intl.formatMessage({id: item.label}), value: item.value}
                                         })}/>
                    </Grid>
                    <Grid item xs={6}>
                        <FormFieldDate label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_VEHICLE_REGISTRATION_DATE"})}
                                       value={dayjs(innerVisitor.vehicleRegistrationDate, Formats.DATE_SIMPLE)}
                                       onChange={(value) => handleChange("vehicleRegistrationDate", value)}/>

                    </Grid>
                    <Grid item xs={6}>
                        <FormFieldSelect label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE"})}
                                         value={innerVisitor.vehicleFuelType}
                                         onChange={(value) => {
                                             handleChange("vehicleFuelType", value)
                                         }}
                                         items={VehicleFuelType.List.map((item) => {
                                             return {label: intl.formatMessage({id: item.label}), value: item.value}
                                         })}/>
                    </Grid>
                    <Grid item xs={6}>
                        <FormFieldSelect label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD"})}
                                         value={innerVisitor.vehicleEmissionStandard}
                                         onChange={(value) => {
                                             handleChange("vehicleEmissionStandard", value)
                                         }}
                                         items={VehicleEmissionStandard.List.map((item) => {
                                             return {label: intl.formatMessage({id: item.label}), value: item.value}
                                         })}/>
                    </Grid>
                    <Grid item xs={6}>
                        <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_ID_NUMBER"})}
                                       placeholder={intl.formatMessage({id: "VMS_REQUEST_VISITOR_ID_NUMBER_REQUIRED"})}
                                       value={innerVisitor.idNumber}
                                       onChange={(value) => {
                                           handleChange("idNumber", value)
                                       }}/>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl variant={'standard'} margin={'normal'}>
                            <Stack spacing={2}>
                                <UploadFileButton
                                    text={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VEHICLE_LICENSE_UPLOAD'})}
                                    onChange={(files) => {
                                        if (files) {
                                            for (let file of files) {
                                                handleUpload(file);
                                            }
                                        }
                                    }}/>
                                {/*{messageMap.has("attachFileVehicleLicense") ?*/}
                                {/*    <FormHelperText*/}
                                {/*        error={messageMap.has("attachFileVehicleLicense")}>{messageMap.get("attachFileVehicleLicense")}</FormHelperText> : null}*/}
                                <List>
                                    {innerVisitor.attachFilesArray.map((item, index) => {
                                        return <ListItem key={index}
                                                         secondaryAction={
                                                             <IconButton edge="end" aria-label="delete"
                                                                         onClick={() => handleRemoveAttachFile(index)}>
                                                                 <DeleteIcon/>
                                                             </IconButton>
                                                         }>
                                            <ListItemText primary={item.fileName}/>
                                        </ListItem>
                                    })}
                                </List>
                            </Stack>
                        </FormControl>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <CancelButton onClick={handleClose}/>
                <SaveButton onClick={handleOk}/>
            </DialogActions>
        </Dialog>
    );
};

export default VisitorDetailDialog;